import React from 'react';
import { Tooltip } from 'antd';
import { PLAN_PRICE_LEVEL_HINTS } from './planCatalogHelpers';
import './plan-price-level-hint.css';

/**
 * Wraps L1/L2/L3 labels with a short hover title explaining the pricing tier.
 */
export default function PlanPriceLevelHint({ level, children, className }) {
  const hint = PLAN_PRICE_LEVEL_HINTS[level];
  if (!hint) return children;

  return (
    <Tooltip title={hint}>
      <span className={className || 'plan-price-level-hint'}>{children}</span>
    </Tooltip>
  );
}
